import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';
import { signInStateHome, signInStateProfile } from '../utils/signInReturn';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  const [isAuth, setIsAuth] = useState<boolean | null>(null);

  useEffect(() => {
    // 在组件挂载时检查认证状态
    setIsAuth(isAuthenticated());
  }, []);

  // 等待检查完成
  if (isAuth === null) {
    return null; // 或者显示加载中
  }

  if (!isAuth) {
    const signInState = location.pathname.startsWith('/profile')
      ? signInStateProfile()
      : signInStateHome();
    return <Navigate to="/sign-in" replace state={signInState} />;
  }

  return children;
};

export default ProtectedRoute;

